<template>
	<div>
		<div class="group-item" :class="itemClass" @contextmenu.prevent="showRightMenu($event)">
			<div class="group-avatar">
				<head-image :size="headImageSize" :name="groupDisplayName" :url="group.headImageThumb"
					variant="group"> </head-image>
			</div>
			<div class="group-name"> {{ groupDisplayName }} </div>
			<slot></slot>
		</div>
		<right-menu ref="rightMenu" @select="onSelectMenu"></right-menu>
	</div>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import RightMenu from "../common/RightMenu.vue";
import { resolveGroupChatDisplayName } from '../../utils/identityDisplay.js';
export default {
	name: "groupItem",
	components: {
		HeadImage,
		RightMenu
	},
	data() {
		return {}
	},
	props: {
		group: {
			type: Object
		},
		active: {
			type: Boolean
		},
		size: {
			type: String,
			default: 'normal'
		},
		menu: {
			type: Boolean,
			default: true
		},
	},
	methods: {
		onSelectMenu(item) {
			this.$emit(item.key.toLowerCase());
		},
		showRightMenu(e) {
			if (this.menu) {
				this.$refs.rightMenu.open(e, this.menuItems);
			}
		}
	},
	computed: {
		headImageSize() {
			if (this.size == 'small') {
				return 34;
			}
			return 42;
		},
		groupDisplayName() {
			return resolveGroupChatDisplayName(this.group) || this.group.name || '群聊';
		},
		itemClass() {
			let clz = "";
			if (this.active) {
				clz += "active"
			}
			if (this.size == 'small') {
				clz += " small"
			}
			return clz;
		},
		isOwner() {
			return this.group.ownerId == this.userStore.userInfo.id;
		},
		isManager() {
			return this.groupStore.isManager(this.group.id, this.userStore.userInfo.id);
		},
		canForwardCard() {
			return this.$permission.canForwardCardMessage
				? this.$permission.canForwardCardMessage()
				: this.$permission.hasRolePermission('message.cardForward');
		},
		canShareCard() {
			return this.canForwardCard && (this.isOwner || this.isManager || this.group.isAllowShareCard);
		},
		menuItems() {
			let items = [];
			items.push({
				key: 'CHAT',
				name: '发送消息',
				icon: 'el-icon-chat-dot-round'
			});
			if (this.canShareCard) {
				items.push({
					key: 'CARD',
					name: '分享名片',
					icon: 'el-icon-share'
				});
			}
			if (this.isOwner) {
				items.push({
					key: 'DISSOLVE',
					name: '解散群聊',
					icon: 'el-icon-delete',
					danger: true
				});
			} else {
				items.push({
					key: 'QUIT',
					name: '退出群聊',
					icon: 'el-icon-close',
					danger: true
				});
			}
			return items;
		}
	}
}
</script>

<style lang="scss" scoped>
.group-item {
	height: 60px;
	display: flex;
	position: relative;
	border-radius: 0;
	margin: 0;
	padding: 6px 12px;
	align-items: center;
	white-space: nowrap;
	cursor: pointer;
	transition: background-color 0.15s ease;

	&::before {
		content: '';
		position: absolute;
		left: 0;
		top: 50%;
		transform: translateY(-50%) scaleY(0);
		width: 3px;
		height: 24px;
		border-radius: 0 2px 2px 0;
		background: var(--im-session-indicator);
		transition: transform 0.2s ease;
	}

	&:hover {
		background-color: rgba(var(--im-primary-rgb), 0.04);
	}

	&.active {
		background-color: rgba(var(--im-primary-rgb), 0.09);

		&::before { transform: translateY(-50%) scaleY(1); }
		.group-name { color: var(--im-session-text); font-weight: 600; }
	}

	&.small {
		height: 42px;
		padding: 4px 10px;
	}

	.group-name {
		flex: 1;
		display: flex;
		align-items: center;
		padding-left: 12px;
		height: 100%;
		text-align: left;
		white-space: nowrap;
		overflow: hidden;
		font-size: 14px;
		font-weight: 500;
		color: var(--im-session-text);
		line-height: 1.4;
	}
}
</style>
